import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';
import { useAuth } from '../context/AuthContext';
import { useWebSocket } from '../hooks/useWebSocket';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { toast } from 'sonner';
import { useEffect, useRef } from 'react';

const DashboardLayout = () => {
  const { token } = useAuth();
  const { notifications, unreadCount, connected, clearNotification, markAllRead } = useWebSocket(token);
  const push = usePushNotifications(token);
  const prevCountRef = useRef(0);

  useEffect(() => {
    if (notifications.length > prevCountRef.current && prevCountRef.current > 0) {
      const latest = notifications[0];
      if (latest && !latest.read) {
        if (latest.type === 'alert_triggered') {
          const icon = latest.trigger_type === 'min' ? 'Prix bas' : 'Prix haut';
          toast.info(`${icon} - ${latest.contract_name} a ${latest.current_price} EUR/MWh pour ${latest.client_name}`, { duration: 8000 });
        } else if (latest.type === 'callback_request') {
          toast.info(`Demande de rappel de ${latest.client_name}`, { duration: 8000 });
        }
      }
    }
    prevCountRef.current = notifications.length;
  }, [notifications]);

  return (
    <div className="min-h-screen bg-white">
      <Sidebar />
      <main className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
        {/* Top bar */}
        <div className="hidden lg:flex items-center justify-end px-8 py-3 border-b border-[#BFC6CC]/10 sticky top-0 z-40 bg-white/80 backdrop-blur-md">
          <NotificationBell
            notifications={notifications}
            unreadCount={unreadCount}
            connected={connected}
            onClear={clearNotification}
            onMarkAllRead={markAllRead}
            push={push}
          />
        </div>
        <div className="p-5 md:p-8 lg:p-10 max-w-[1440px]">
          <Outlet />
        </div>
      </main>
      {/* Mobile notification bell */}
      <div className="lg:hidden fixed top-0 right-14 h-16 z-50 flex items-center">
        <NotificationBell
          notifications={notifications}
          unreadCount={unreadCount}
          connected={connected}
          onClear={clearNotification}
          onMarkAllRead={markAllRead}
          push={push}
        />
      </div>
    </div>
  );
};

export default DashboardLayout;
